/**
* https://tc39.es/ecma262/#sec-toobject
*/
export function ToObject(arg) {
	if (arg == null) {
		throw new TypeError("undefined/null cannot be converted to object");
	}
	return Object(arg);
}
